<script lang="ts">
    
    import { createEventDispatcher, onDestroy, onMount } from "svelte";

    type Message = {
        content: string;
        show: boolean;
        fontSize: string;
    };

    const dispatch = createEventDispatcher();
    
    let messages: Message[] = [
        {
            content: '3',
            show: false,
            fontSize: '5rem',
        },
        {
            content: '2',
            show: false,
            fontSize: '5rem',
        },
        {
            content: '1',
            show: false,
            fontSize: '5rem',
        },
        {
            content: '¡Vamos!',
            show: false,
            fontSize: '2rem',
        },
    ];
    let isStarted = false;
    let time = 0;
    let interval: number;

    onMount(startCountdown);
    onDestroy(stopCountdown);

    function startCountdown(): void {
        if (isStarted) {
            return;
        }
        isStarted = true;
        countdownTick();
        interval = window.setInterval(countdownTick, 1000);
    }

    function stopCountdown(): void {
        isStarted = false;
        window.clearInterval(interval);
    }

    function countdownTick(): void {
        if (time === messages.length) {
            stopCountdown();
            dispatch('end');
            return;
        }
        const message = messages[time];
        message.show = true;
        messages = messages;
        time++;
    }

</script>

<style lang="scss">

    .countdown {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .message {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .content {
            $shadow-color: #000;
            opacity: 0;
            color: #fff;
            text-shadow: 0 0 4px $shadow-color;
        }

        &.show {

            .content {
                font-family: 'Grandstander', cursive;
                font-size: var(--font-size);
                animation: content-anim 1s;
            }
            
        }
    }

    @keyframes content-anim {
        0% {
            opacity: 0;
            transform: scale(1);
        }
        80% {
            opacity: 1;
            transform: scale(2);
        }
        10% {
            opacity: 0;
            transform: scale(2);
        }
    }

</style>

<div class="countdown">
    {#each messages as { content, show, fontSize }}
    <div class="message" style="--font-size: {fontSize}" class:show>
        <div class="content">{content}</div>
    </div>
    {/each}
</div>
